export enum Languages {
  SPANISH = 'es',
  ENGLISH = 'en'
}

export const LanguagesLabels: Record<Languages, string> = {
  [Languages.SPANISH]: 'common.languages_spanish',
  [Languages.ENGLISH]: 'common.languages_english'
};
